import { useShowNav } from "@/context/HeaderShowNav";
import styles from "./HeaderBurgerMenu.module.css";

function HeaderBurgerMenu() {
  const { showNav, setShowNav } = useShowNav();

  return (
    <button
      className={`${styles.container} ${showNav ? styles.isActive : ""}`}
      onClick={() => setShowNav((show) => !show)}
    />
  );
}

export default HeaderBurgerMenu;
